import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from "react-bootstrap";

class TimeZoneSelect extends Component {
  static propTypes = {
    handleChange:       PropTypes.func.isRequired,
    timezone:           PropTypes.number.isRequired,
    officeHoursEnabled: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);
    this.state = { value: this.props.timezone };
  }

  handleChange(event) {
    if(this.props.handleChange) {
      let value = event.target.value;
      this.setState({ value });
      this.props.handleChange(value);
    }
  }

  render() {
    return (
      <FormControl
        componentClass="select"
        type="select" className="form-control timezone-select" value={this.state.value}
        onChange={this.handleChange.bind(this)} wrapperClassName="p-0" name="timezone_select"
        disabled={!this.props.officeHoursEnabled}>
        <option value="American Samoa">American Samoa</option>
        <option value="International Date Line West">International Date Line West</option>
        <option value="Midway Island">Midway Island</option>
        <option value="Hawaii">Hawaii</option>
        <option value="Alaska">Alaska</option>
        <option value="Pacific Time (US & Canada)">Pacific Time (US & Canada)</option>
        <option value="Tijuana">Tijuana</option>
        <option value="Arizona">Arizona</option>
        <option value="Chihuahua">Chihuahua</option>
        <option value="Mazatlan">Mazatlan</option>
        <option value="Mountain Time (US & Canada)">Mountain Time (US & Canada)</option>
        <option value="Central America">Central America</option>
        <option value="Central Time (US & Canada)">Central Time (US & Canada)</option>
        <option value="Guadalajara">Guadalajara</option>
        <option value="Mexico City">Mexico City</option>
        <option value="Monterrey">Monterrey</option>
        <option value="Saskatchewan">Saskatchewan</option>
        <option value="Bogota">Bogota</option>
        <option value="Eastern Time (US & Canada)">Eastern Time (US & Canada)</option>
        <option value="Indiana (East)">Indiana (East)</option>
        <option value="Lima">Lima</option>
        <option value="Quito">Quito</option>
        <option value="Atlantic Time (Canada)">Atlantic Time (Canada)</option>
        <option value="Caracas">Caracas</option>
        <option value="Georgetown">Georgetown</option>
        <option value="La Paz">La Paz</option>
        <option value="Santiago">Santiago</option>
        <option value="Newfoundland">Newfoundland</option>
        <option value="Brasilia">Brasilia</option>
        <option value="Buenos Aires">Buenos Aires</option>
        <option value="Greenland">Greenland</option>
        <option value="Montevideo">Montevideo</option>
        <option value="Mid-Atlantic">Mid-Atlantic</option>
        <option value="Azores">Azores</option>
        <option value="Cape Verde Is.">Cape Verde Is.</option>
        <option value="Casablanca">Casablanca</option>
        <option value="Dublin">Dublin</option>
        <option value="Edinburgh">Edinburgh</option>
        <option value="Lisbon">Lisbon</option>
        <option value="London">London</option>
        <option value="Monrovia">Monrovia</option>
        <option value="UTC">UTC</option>
        <option value="Amsterdam">Amsterdam</option>
        <option value="Belgrade">Belgrade</option>
        <option value="Berlin">Berlin</option>
        <option value="Bern">Bern</option>
        <option value="Bratislava">Bratislava</option>
        <option value="Brussels">Brussels</option>
        <option value="Budapest">Budapest</option>
        <option value="Copenhagen">Copenhagen</option>
        <option value="Ljubljana">Ljubljana</option>
        <option value="Madrid">Madrid</option>
        <option value="Paris">Paris</option>
        <option value="Prague">Prague</option>
        <option value="Rome">Rome</option>
        <option value="Sarajevo">Sarajevo</option>
        <option value="Skopje">Skopje</option>
        <option value="Stockholm">Stockholm</option>
        <option value="Vienna">Vienna</option>
        <option value="Warsaw">Warsaw</option>
        <option value="West Central Africa">West Central Africa</option>
        <option value="Zagreb">Zagreb</option>
        <option value="Zurich">Zurich</option>
        <option value="Athens">Athens</option>
        <option value="Bucharest">Bucharest</option>
        <option value="Cairo">Cairo</option>
        <option value="Harare">Harare</option>
        <option value="Helsinki">Helsinki</option>
        <option value="Jerusalem">Jerusalem</option>
        <option value="Kaliningrad">Kaliningrad</option>
        <option value="Kyiv">Kyiv</option>
        <option value="Pretoria">Pretoria</option>
        <option value="Riga">Riga</option>
        <option value="Sofia">Sofia</option>
        <option value="Tallinn">Tallinn</option>
        <option value="Vilnius">Vilnius</option>
        <option value="Baghdad">Baghdad</option>
        <option value="Istanbul">Istanbul</option>
        <option value="Kuwait">Kuwait</option>
        <option value="Minsk">Minsk</option>
        <option value="Moscow">Moscow</option>
        <option value="Nairobi">Nairobi</option>
        <option value="Riyadh">Riyadh</option>
        <option value="St. Petersburg">St. Petersburg</option>
        <option value="Volgograd">Volgograd</option>
        <option value="Tehran">Tehran</option>
        <option value="Abu Dhabi">Abu Dhabi</option>
        <option value="Baku">Baku</option>
        <option value="Muscat">Muscat</option>
        <option value="Samara">Samara</option>
        <option value="Tbilisi">Tbilisi</option>
        <option value="Yerevan">Yerevan</option>
        <option value="Kabul">Kabul</option>
        <option value="Ekaterinburg">Ekaterinburg</option>
        <option value="Islamabad">Islamabad</option>
        <option value="Karachi">Karachi</option>
        <option value="Tashkent">Tashkent</option>
        <option value="Chennai">Chennai</option>
        <option value="Kolkata">Kolkata</option>
        <option value="Mumbai">Mumbai</option>
        <option value="New Delhi">New Delhi</option>
        <option value="Sri Jayawardenepura">Sri Jayawardenepura</option>
        <option value="Kathmandu">Kathmandu</option>
        <option value="Almaty">Almaty</option>
        <option value="Astana">Astana</option>
        <option value="Dhaka">Dhaka</option>
        <option value="Urumqi">Urumqi</option>
        <option value="Rangoon">Rangoon</option>
        <option value="Bangkok">Bangkok</option>
        <option value="Hanoi">Hanoi</option>
        <option value="Jakarta">Jakarta</option>
        <option value="Krasnoyarsk">Krasnoyarsk</option>
        <option value="Novosibirsk">Novosibirsk</option>
        <option value="Beijing">Beijing</option>
        <option value="Chongqing">Chongqing</option>
        <option value="Hong Kong">Hong Kong</option>
        <option value="Irkutsk">Irkutsk</option>
        <option value="Kuala Lumpur">Kuala Lumpur</option>
        <option value="Perth">Perth</option>
        <option value="Singapore">Singapore</option>
        <option value="Taipei">Taipei</option>
        <option value="Ulaanbaatar">Ulaanbaatar</option>
        <option value="Osaka">Osaka</option>
        <option value="Sapporo">Sapporo</option>
        <option value="Seoul">Seoul</option>
        <option value="Tokyo">Tokyo</option>
        <option value="Yakutsk">Yakutsk</option>
        <option value="Adelaide">Adelaide</option>
        <option value="Darwin">Darwin</option>
        <option value="Brisbane">Brisbane</option>
        <option value="Canberra">Canberra</option>
        <option value="Guam">Guam</option>
        <option value="Hobart">Hobart</option>
        <option value="Melbourne">Melbourne</option>
        <option value="Port Moresby">Port Moresby</option>
        <option value="Sydney">Sydney</option>
        <option value="Vladivostok">Vladivostok</option>
        <option value="Magadan">Magadan</option>
        <option value="New Caledonia">New Caledonia</option>
        <option value="Solomon Is.">Solomon Is.</option>
        <option value="Srednekolymsk">Srednekolymsk</option>
        <option value="Auckland">Auckland</option>
        <option value="Fiji">Fiji</option>
        <option value="Kamchatka">Kamchatka</option>
        <option value="Marshall Is.">Marshall Is.</option>
        <option value="Wellington">Wellington</option>
        <option value="Chatham Is.">Chatham Is.</option>
        <option value="Nuku'alofa">Nuku&#39;alofa</option>
        <option value="Samoa">Samoa</option>
        <option value="Tokelau Is.">Tokelau Is.</option>
      </FormControl>
    );
  }
}

export default TimeZoneSelect;
